import { Center, Space } from "@mantine/core";
import { Page } from "@/components/page";
import { ErrorCard } from "@/components/error-card";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { ButtonLink } from "@/components/button-link";

const PaymentFailedSearchSchema = z.object({
  message: z
    .string()
    .optional()
    .default("An unknown error has occured.  Please try again later"),
});

export const Route = createFileRoute("/_landing/payment-failed")({
  validateSearch: zodValidator(PaymentFailedSearchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  const { message } = Route.useSearch();

  return (
    <Page title="Payment Failed">
      <Space h="xl" />
      <ErrorCard title="An error has occured" message={message} />
      <Center mt="xl">
        <ButtonLink to="/">Go home</ButtonLink>
      </Center>
    </Page>
  );
}
